import { render, staticRenderFns } from "./ElAvatar.vue?vue&type=template&id=40a08069&scoped=true&"
import script from "./ElAvatar.vue?vue&type=script&lang=ts&"
export * from "./ElAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./ElAvatar.vue?vue&type=style&index=0&id=40a08069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a08069",
  null
  
)

export default component.exports